<div class="relative h-full w-sidebar">
  <div class="sticky top-0 flex h-screen w-full flex-col items-center">
    <app-sidemenu-nav
      class="mt-header flex w-full flex-col"
      [selectedMenuItem]="selectedMenuItem"
      [selectedSubmenuItem]="selectedSubmenuItem"
      (subMenuItemSelect)="onSelectSubMenuItem($event)"
      (menuItemSelect)="onSelectMenuItem($event)"
    />
    <div class="mb-6 mt-auto w-full space-y-2">
      <app-plan-usage-indicator />
      <app-user-menu />
    </div>
  </div>
</div>
